/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ---------- Kylemark: Request a Quote under the Kefi "Add to Cart" on bundle deal pages (3 Nov 2026) ----------
 * The quote snippet (snippets/quote-request.liquid) puts its .kmq-pdp button under the theme's buy buttons.
 * On Kefi bundle pages that sits above the bundle builder, so we hide it there and add our own button
 * under Kefi's Add to Cart. Clicking it adds the bundle (via Kefi's own button), waits for the basket
 * to change, then opens the quote popup through the slide-out basket's "Request Basket As Quote" button.
 */
(function(){
  var LABEL='Request a Quote<small>Instant quote by email &ndash; save up to 12%</small>';
  function css(){
    if(document.getElementById('kmqb-css'))return;
    var s=document.createElement('style');s.id='kmqb-css';
    s.textContent='.km-bundle-page .product-form__payment-container + .kmq-pdp,.km-bundle-page .product-form__payment-container ~ .kmq-pdp-msg{display:none!important}'+
      '.kmqb{margin-top:12px!important}';
    document.head.appendChild(s);
  }
  function cartKey(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){return c.item_count+'|'+c.total_price;});}
  function openQuote(){
    var b=document.querySelector('.mini-cart__button-container + .kmq-btn, .cart-recap__checkout + .kmq-btn');
    if(b){b.click();return true;}
    return false;
  }
  function msg(btn,text){
    var m=btn.nextElementSibling;
    if(!(m&&m.classList.contains('kmq-pdp-msg'))){m=document.createElement('p');m.className='kmq-pdp-msg';btn.after(m);}
    m.textContent=text;
  }
  function clearMsg(btn){var m=btn.nextElementSibling;if(m&&m.classList.contains('kmq-pdp-msg'))m.remove();}
  function onClick(btn,add){
    clearMsg(btn);
    if(add.disabled){msg(btn,'Choose all the items in your bundle above, then click Request a Quote.');return;}
    btn.disabled=true;btn.innerHTML='Adding to your basket...';
    var done=false;
    function finish(ok){
      if(done)return;done=true;btn.disabled=false;btn.innerHTML=LABEL;
      if(ok){setTimeout(function(){if(!openQuote())location.href='/cart';},800);}
      else msg(btn,'Sorry, we could not add your bundle. Please try Add to Cart, then use Request Basket As Quote in your basket.');
    }
    cartKey().then(function(before){
      add.click();
      var tries=0;
      (function poll(){
        if(done)return;
        if(++tries>24){finish(false);return;}
        setTimeout(function(){cartKey().then(function(now){if(now!==before)finish(true);else poll();}).catch(poll);},500);
      })();
    }).catch(function(){add.click();});
  }
  function place(){
    var add=document.querySelector('[id^="kefi_"] #addToCartButton');
    if(!add)return;
    document.documentElement.classList.add('km-bundle-page');css();
    var next=add.nextElementSibling;
    if(next&&next.classList.contains('kmqb'))return;
    var b=document.createElement('button');b.type='button';b.className='kmq-pdp kmqb';b.innerHTML=LABEL;
    b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();onClick(b,add);});
    add.after(b);
  }
  function init(){
    place();
    var t=null;
    new MutationObserver(function(){if(t)return;t=setTimeout(function(){t=null;place();},150);}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* ---------- Kylemark: show the chosen colour name on Kefi bundle swatches (3 Nov 2026) ----------
 * Kefi's image swatches show no colour name. Kefi keeps the selected variant ("Sky Blue / XS") in the title
 * of the option container, so we copy the colour part next to the "Colour" label: "Colour: Sky Blue".
 */
(function(){
  function run(){
    document.querySelectorAll('[id^="kefi_"] [class*="VariantOptionContainer__"]').forEach(function(c){
      var t=c.querySelector('[class*="variantContainer__"][title]');
      if(!t)return;
      var colour=String(t.getAttribute('title')).split(' / ')[0].trim();
      c.querySelectorAll('label[class*="selectLabel__"]').forEach(function(l){
        var base=l.getAttribute('data-km-label');
        if(!base){base=l.textContent.trim();if(!/^colou?r$/i.test(base))return;l.setAttribute('data-km-label',base);}
        var s=l.querySelector('.km-colour-name');
        if(!s){s=document.createElement('span');s.className='km-colour-name';s.style.cssText='font-weight:600;margin-left:4px';l.appendChild(s);}
        var txt=': '+colour;
        if(s.textContent!==txt)s.textContent=txt;
      });
    });
  }
  function init(){
    run();
    var t=null;
    new MutationObserver(function(){if(t)return;t=setTimeout(function(){t=null;run();},120);})
      .observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['title','class']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* ---------- Kylemark: "Product info" button on each product in Kefi bundle deals (4 Nov 2026) ----------
 * Adds an "i Info" button next to each product title inside the Kefi bundle builder. Clicking it opens a
 * popup with that garment's description and its "Full Product Info" box, taken from the
 * product's own page (looked up by the card's data-product-id via search suggest, then cached).
 */
(function(){
  var cache={};
  function css(){
    if(document.getElementById('kmpi-css'))return;
    var s=document.createElement('style');s.id='kmpi-css';
    s.textContent=
      '.kmpi-btn{display:inline-flex;align-items:center;gap:4px;margin:4px 0 2px;padding:3px 10px;border:1px solid #0a2c49;border-radius:999px;background:#fff;color:#0a2c49;font:600 12px/1.3 inherit;cursor:pointer}'+
      '.kmpi-btn:hover{background:#0a2c49;color:#fff}'+
      '.kmpi-btn i{display:inline-grid;place-items:center;width:14px;height:14px;border-radius:50%;background:#0a2c49;color:#fff;font:700 10px/1 Georgia,serif;font-style:italic}'+
      '.kmpi-btn:hover i{background:#fff;color:#0a2c49}'+
      '.kmpi{position:fixed;inset:0;z-index:100001;background:rgba(10,44,73,.6);display:flex;align-items:center;justify-content:center;padding:14px}'+
      '.kmpi[hidden]{display:none}'+
      '.kmpi__box{position:relative;background:#fff;border-radius:12px;width:100%;max-width:640px;max-height:88vh;overflow:auto;padding:24px 22px 20px;border-top:5px solid #b08b2d;color:#223042;font-size:14px;line-height:1.55}'+
      '.kmpi__x{position:absolute;top:6px;right:10px;border:0;background:none;font-size:30px;line-height:1;cursor:pointer;color:#0a2c49}'+
      '.kmpi__t{margin:0 30px 12px 0;font-size:19px;font-weight:700;color:#0a2c49;line-height:1.3}'+
      '.kmpi__h{margin:16px 0 6px;font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#b08b2d}'+
      '.kmpi__body p{margin:0 0 8px}.kmpi__body ul{margin:0 0 8px 18px;padding:0}.kmpi__body img{max-width:100%;height:auto}'+
      '.kmpi__info h2{display:none}'+
      '.kmpi__a{display:inline-block;margin-top:14px;color:#0a2c49;font-weight:700}'+
      '.kmpi__load{color:#5b6b78}';
    document.head.appendChild(s);
  }
  var modal;
  function getModal(){
    if(modal)return modal;
    modal=document.createElement('div');modal.className='kmpi';modal.hidden=true;
    modal.innerHTML='<div class="kmpi__box" role="dialog" aria-modal="true"><button type="button" class="kmpi__x" aria-label="Close">&times;</button><div class="kmpi__c"></div></div>';
    modal.addEventListener('click',function(e){if(e.target===modal||e.target.closest('.kmpi__x'))close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)close();});
    document.body.appendChild(modal);return modal;
  }
  function close(){modal.hidden=true;document.documentElement.style.overflow='';}
  function esc(t){var d=document.createElement('div');d.textContent=t;return d.innerHTML;}
  function load(id,title){
    if(cache[id])return cache[id];
    cache[id]=fetch('/search/suggest.json?q='+encodeURIComponent(title)+'&resources[type]=product&resources[limit]=10',{credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(j){
        var ps=(j.resources&&j.resources.results&&j.resources.results.products)||[];
        var p=ps.filter(function(x){return String(x.id)===String(id);})[0]||ps[0];
        if(!p)throw new Error('not found');
        return Promise.all([
          fetch('/products/'+p.handle+'.js').then(function(r){return r.json();}),
          fetch('/products/'+p.handle).then(function(r){return r.text();})
        ]).then(function(res){
          var doc=new DOMParser().parseFromString(res[1],'text/html');
          var info=doc.querySelector('.cw-full-product-info');
          return {title:res[0].title,desc:res[0].description||'',info:info?info.innerHTML:'',url:'/products/'+p.handle};
        });
      });
    cache[id].catch(function(){delete cache[id];});
    return cache[id];
  }
  function open(id,title){
    var m=getModal(),c=m.querySelector('.kmpi__c');
    c.innerHTML='<p class="kmpi__t">'+esc(title)+'</p><p class="kmpi__load">Loading product info&hellip;</p>';
    m.hidden=false;document.documentElement.style.overflow='hidden';
    load(id,title).then(function(d){
      var h='<p class="kmpi__t">'+esc(d.title)+'</p>';
      if(d.desc)h+='<div class="kmpi__body">'+d.desc+'</div>';
      if(d.info)h+='<p class="kmpi__h">Full product info</p><div class="kmpi__body kmpi__info">'+d.info+'</div>';
      h+='<a class="kmpi__a" href="'+d.url+'" target="_blank" rel="noopener">View full product page &rarr;</a>';
      c.innerHTML=h;
    }).catch(function(){
      c.innerHTML='<p class="kmpi__t">'+esc(title)+'</p><p>Sorry, we couldn\'t load the product info. Please try again, or call us on 01292 618344.</p>';
    });
  }
  function run(){
    var cards=document.querySelectorAll('[id^="kefi_"] [class*="productWrapper__"][data-product-id]');
    if(!cards.length)return;
    css();
    cards.forEach(function(card){
      var t=card.querySelector('[data-label="Product Title"]');
      if(!t)return;
      var next=t.nextElementSibling;
      if(next&&next.classList.contains('kmpi-btn'))return;
      var id=card.getAttribute('data-product-id'),title=t.getAttribute('title')||t.textContent.trim();
      var b=document.createElement('button');b.type='button';b.className='kmpi-btn';b.innerHTML='<i>i</i>Product info';
      b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();open(id,title);});
      t.after(b);
    });
  }
  function init(){
    run();
    var q=null;
    new MutationObserver(function(){if(q)return;q=setTimeout(function(){q=null;run();},150);}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
